import ApiService from "@/services/api.service";
import Vue from 'vue';

const route = 'profiles';

const profileCommissions = {
    get(_profileId, _administratorId) {
        return new Promise((resolve, reject) => {
            ApiService.get(route, _profileId + '/administrators/' + _administratorId + '/commissions').then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },
    set(_profileId, _administratorId, _params) {
        var params = {
            default: {
                billing_commission: _params.default.billing_commission,
                billing_commission_type: _params.default.billing_commission_type,
                comission: _params.default.comission,
                comission_contemplation: _params.default.comission_contemplation,
                commissioned_vehicles: _params.default.commissioned_vehicles,
                deployment_commision: _params.default.deployment_commision,
                groups: _params.default.groups,
                inadvertencies: _params.default.inadvertencies,
                max_quotes: _params.default.max_quotes,
                min_quotes: _params.default.min_quotes
            },
            bonus: {
                bonus_1: _params.bonus.bonus_1,
                bonus_2: _params.bonus.bonus_2,
                by_quotas: _params.bonus.by_quotas,
                cut_value: _params.bonus.cut_value,
                final_date: _params.bonus.final_date != "" ? Vue.moment(_params.bonus.final_date).format('YYYY-MM-DD') : null,
                initial_date: _params.bonus.initial_date != "" ? Vue.moment(_params.bonus.initial_date).format('YYYY-MM-DD') : null,
                qtd_quotas: _params.bonus.qtd_quotas
            },
            billing: {
                ranges: _params.billing.ranges
            },
            campaign: {
                closing_months: _params.campaign.closing_months,
                quotas: _params.campaign.quotas,
                amounts: _params.campaign.amounts,
                min_quantity: _params.campaign.min_quantity,
                commission: _params.campaign.commission,
                final_date: _params.campaign.final_date != "" ? Vue.moment(_params.campaign.final_date).format('YYYY-MM-DD') : null,
                initial_date: _params.campaign.initial_date != "" ? Vue.moment(_params.campaign.initial_date).format('YYYY-MM-DD') : null,
            },
            installments: _params.installments,
            inadvertencies: _params.inadvertencies,
            surplus: {
                min_value: _params.surplus.min_value,
                commision_on_first_installment: _params.surplus.commision_on_first_installment,
                commision_on_second_installment: _params.surplus.commision_on_second_installment
            },
            type_sales: _params.type_sales
        };

        console.log(params)

        return new Promise((resolve, reject) => {
            ApiService.post(route + "/" + _profileId + '/administrators/' + _administratorId + '/commissions', params).then(({ data }) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }

};

export default profileCommissions;